const { get, adminCall } = require("./_utils");
const mime = require("mime-types")

async function socketRead(uid) {
  try {
    let file = await adminCall("file.read", { uid })
    let { list } = global.store.getState()
    let type = mime.lookup(list.file[uid].ext)
    return new Blob([Buffer.from(file)], { type })
  } catch (err) {
    console.error(err)
    return Promise.reject(err);
  }
}

async function streamRead(uid, chunkSize, handler, onProgress) {
  const chunksArray = []
  let downloadedBytes = 0

  let answer = await global.socket.request("file.downstream", { uid, chunkSize })
  do {
    answer = await global.socket.request(answer.eventName)
    if (answer) {
      chunksArray.push(answer.chunk)
      downloadedBytes += answer.chunk.byteLength
      if (onProgress) onProgress(downloadedBytes)
    }
  } while (answer)

  //Call param function to convert to the proper data type
  return handler(chunksArray)

}

async function httpRead(uid) {
  try {
    let file = await get('/file', {
      params: { uid },
      responseType: 'blob',
      timeout: null
    }, true);
    return file.data;
  } catch (err) {
    return Promise.reject(err);
  }
}

module.exports = {
  //download
  read: async (uid) => {
    if (global.socket && global.socket.connected) {
      return socketRead(uid);
    } else return httpRead(uid);
  },
  httpRead,
  socketRead,
  streamRead,
  //create
  //modify
  remove: (uid) => adminCall('file.remove', { uid }),
}